import { BaseModel } from './base.model'
import { AnswerOption } from './answer-option.model'
import { QuestionDecorator } from 'decorators'

export class Question extends BaseModel<Question> {
  static DEFAULT_ATTRIBUTES = {
    answerOptions: [],
    shuffleAnswerOptions: true
  }

  answerOptions: AnswerOption[]
  answerOptionsCount: number
  comment: string
  correctAnswerValue: string|number|number[]
  folderId: number
  hint: string
  name: string
  shuffleAnswerOptions: boolean
  state: string
  type: string
  sectionId: number
  examAudioId: number
  videoId: number
  control: boolean

  private decorator: QuestionDecorator

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  isSelect(): boolean {
    return this.type == 'select'
  }

  isMultiselect(): boolean {
    return this.type == 'multiselect'
  }

  isString(): boolean {
    return this.type == 'string'
  }

  decorate(): QuestionDecorator {
    if(!this.decorator) { this.decorator = new QuestionDecorator(this) }
    return this.decorator
  }
  
  /**
   * Just remove all html tags
   */
  get displayName(): string {
    let regex = /(<([^>]+)>)/ig
    return this.name.replace(regex, "")
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/question.model.ts